@if (comparePlansConfig?.showNavigation) {
  <navigation
    data-test-id="comparePlansNavigation"
    (query)="filterBenefits($event)"
  ></navigation>
}

<article class="ComparePlans">
  @if (plans.length > 2) {
    <section
      class="ComparePlans__Scroll"
      [ngClass]="{ 'ComparePlans__Scroll--Scrolled': isScrolled }"
      (click)="scrollMobile()"
    >
      <icon
        data-test-id="comparePlansChevronRightIcon"
        [name]="'chevron_right'"
        [config]="{ type: 'link', size: 'medium' }"
      ></icon>
      <icon
        data-test-id="comparePlansChevronLeftIcon"
        [name]="'chevron_left'"
        [config]="{ type: 'link', size: 'medium' }"
      ></icon>
    </section>
  }

  <compare-plan-header
    (complete)="complete.emit($event)"
    [plans]="plans"
    data-test-id="comparePlansHeader"
    [comparePlansConfig]="comparePlansConfig"
    [highlightedPlans]="highlightedInCompare"
    [isScrolled]="isScrolled"
    [comparePlansConstantText]="comparePlansConstantText"
    (close)="closeCompare()"
  >
  </compare-plan-header>

  <article #content class="ComparePlans__Content">
    @for (
      benefit of allBenefits;
      track benefit.planKey;
      let benefitIndex = $index
    ) {
      <ng-container
        [attr.data-test-id]="'comparePlansContent-' + benefitIndex"
        *ngTemplateOutlet="comparePlansRow; context: { benefit }"
      ></ng-container>
    }
    @if (singlePlanSelectionDetail?.showLinks) {
      <ng-container
        data-test-id="comparePlansDetailLink"
        *ngTemplateOutlet="comparePlansRow"
      ></ng-container>
    }
    @if (comparePlansConfig.showResourcesAsBenefit) {
      <ng-container
        data-test-id="comparePlansResourcesAsBenefit"
        *ngTemplateOutlet="
          comparePlansRow;
          context: { benefit: resourcesBenefit }
        "
      ></ng-container>
    }
  </article>

  <ng-template #comparePlansRow let-benefit="benefit">
    <section class="ComparePlans__Row">
      <div class="container">
        <div
          class="ComparePlans__Cells"
          [ngClass]="{ 'ComparePlans__Cells--Scrolled': isScrolled }"
        >
          <div class="ComparePlans__Cell">
            <div class="u-flex u-alignCenter">
              <p
                data-test-id="comparePlansBenefitLabel"
                class="t-data t-bold"
                [innerHTML]="getLabel(benefit)"
              ></p>
            </div>
          </div>

          @for (plan of plans; track plan.id) {
            <div class="ComparePlans__Cell">
              @if (benefit) {
                @if (benefit.type === 'document') {
                  <ng-container
                    [attr.data-test-id]="
                      'comparePlansBenefitTypeDocument-' + plan.id
                    "
                    *ngTemplateOutlet="documentsTemplate; context: { plan }"
                  ></ng-container>
                } @else if (benefit.type !== 'link') {
                  <p
                    class="t-data"
                    [attr.data-test-id]="
                      'comparePlansBenefitTypeNotLink-' + plan.id
                    "
                    [innerHTML]="
                      plansService.getBenefitFromLabel(
                        plan,
                        benefit,
                        subsidyAmount
                      ).value
                    "
                  ></p>
                } @else {
                  @if (
                    plansService.getBenefitFromLabel(
                      plan,
                      benefit,
                      subsidyAmount
                    ).value
                  ) {
                    <a
                      class="t-link"
                      [attr.data-test-id]="
                        'comparePlansBenefitLinkLabel-' + plan.id
                      "
                      [href]="
                        plansService.getBenefitFromLabel(
                          plan,
                          benefit,
                          subsidyAmount
                        ).value
                      "
                      target="_blank"
                      [innerHTML]="
                        comparePlansConfig?.label?.linkLabel ||
                        comparePlansConstantText.ComparelabelLinkText
                      "
                    >
                    </a>
                  } @else {
                    <p
                      [attr.data-test-id]="
                        'comparePlansBenefitNoValueLabel-' + plan.id
                      "
                      class="t-data"
                      [innerHTML]="
                        comparePlansConfig?.label?.noValueLabel || 'N/A'
                      "
                    ></p>
                  }
                }
              } @else if (singlePlanSelectionDetail?.showLinks) {
                @for (link of plan.links; track link.url) {
                  <div class="u-flex ComparePlans__CellLinks">
                    <icon
                      [attr.data-test-id]="
                        'comparePlansBenefit_singlePlanSelectionLinkUrl-' +
                        link.url
                      "
                      [name]="link.icon || 'pdf'"
                    ></icon>
                    <a
                      [attr.data-test-id]="
                        'comparePlansBenefit_singlePlanSelectionLinkLabel-' +
                        link.url
                      "
                      class="t-data t-link"
                      target="_blank"
                      [attr.href]="link.url"
                      [innerHTML]="link.label"
                    >
                    </a>
                  </div>
                }
              }
            </div>
          }
        </div>
      </div>
    </section>
  </ng-template>

  @if (
    (showFooter || comparePlansConfig?.showFooter) &&
    !comparePlansConfig.showResourcesAsBenefit
  ) {
    <footer
      #footer
      class="ComparePlans__Footer"
      data-test-id="comparePlansFooter"
    >
      <section class="ComparePlans__DocumentsRow">
        <div class="container">
          <div
            class="ComparePlans__Cells"
            [ngClass]="{ 'ComparePlans__Cells--Scrolled': isScrolled }"
          >
            <div
              data-test-id="comparePlansDocumentRow"
              class="ComparePlans__Cell"
            ></div>
            @for (plan of plans; track plan; let planIndex = $index) {
              <div class="ComparePlans__Cell">
                <ng-container
                  [attr.data-test-id]="
                    'comparePlansDocumentTemplate-' + planIndex
                  "
                  *ngTemplateOutlet="documentsTemplate; context: { plan }"
                ></ng-container>
              </div>
            }
          </div>
        </div>
      </section>
    </footer>
  }

  <ng-template #documentsTemplate let-plan="plan">
    @if (
      comparePlansConfig?.displayAllDocuments ||
      comparePlansConfig?.displayDocuments
    ) {
      @for (document of documentList(plan); track document.document_id) {
        <ng-container
          [attr.data-test-id]="
            'comparePlansDocumentList-' + document.document_id
          "
          *ngTemplateOutlet="
            documentLink;
            context: {
              link: {
                url: document.document_id,
                label: document.label || formatDocumentName(document.type),
              },
            }
          "
        ></ng-container>
      }
    } @else if (plan.documents) {
      <div class="ComparePlans__AllBenefits">
        <ng-container
          data-test-id="comparePlansDocumentLink"
          *ngTemplateOutlet="
            documentLink;
            context: {
              link: {
                url: plan.documents,
                label:
                  'ALL ' +
                  plan.display_name +
                  ' ' +
                  comparePlansConstantText.benefitText,
              },
            }
          "
        ></ng-container>
      </div>
    }
  </ng-template>

  <ng-template #documentLink let-link="link">
    <div>
      <a
        class="ComparePlans__DocumentLink u-flex"
        target="_blank"
        [href]="link.url"
      >
        <icon
          data-test-id="comparePlansDocumentLinkIcon"
          name="pdf"
          class="ComparePlans__Document--Icon"
          [config]="{ fill: 'primary' }"
        ></icon>
        <span
          data-test-id="comparePlansDocumentLinkLabel"
          class="t-data t-bold"
          [innerHTML]="link.label"
        ></span>
      </a>
    </div>
  </ng-template>
</article>
